import React from 'react';
import PropTypes from 'prop-types';

// Components
import ListCard from '../../../components/ListCard';
import BadgeStatusWidget from '../../../components/BadgeStatusWidget';

// Constants
import { T, FONT_MONO } from '../../../constants/tokens';

export default function BadgeListCard({ badge, onClick, selectedCardObject }) {
  const holder = badge.getBelongsTo();
  const statusColor = badge.getLastSeenRoom()?.getAlertStatus()?.getColor()?.main;

  return (
    <ListCard
      statusColor={statusColor}
      onClick={onClick}
      isSelected={selectedCardObject === badge}
      selectedColor={statusColor}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontFamily: FONT_MONO,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '20px',
              color: T.ink,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {badge.getSerialNumber()}
          </div>
          <div
            style={{
              fontFamily: FONT_MONO,
              fontSize: 12,
              lineHeight: '16px',
              color: T.muted,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {holder ? holder.getName() : 'Unassigned'}
          </div>
        </div>

        <div style={{ flex: 'none' }}>
          <BadgeStatusWidget badge={badge} />
        </div>
      </div>
    </ListCard>
  );
}

BadgeListCard.propTypes = {
  badge: PropTypes.object,
  onClick: PropTypes.func,
  selectedCardObject: PropTypes.object
};
